import fetchInstance from "../fetchInstance";
import {
  FOGOT_PASSWORD_SEND_VERIFICATION,
  LOGIN_BY_EMAIL,
  LOGIN_BY_GOOGLE,
  REGISTER_BY_EMAIL,
  REGISTER_BY_GOOGLE,
  RESEND_VERIFICATION,
  RESET_PASSWORD,
  VERIFY_EMAIL,
} from "../apis";

export const registerByGoogle = async (code, walletAddress) => {
  return await fetchInstance(REGISTER_BY_GOOGLE, {
    method: "POST",
    body: JSON.stringify({ code, walletAddress }),
  });
};

export const loginByGoogle = async (code) => {
  return await fetchInstance(LOGIN_BY_GOOGLE, {
    method: "POST",
    body: JSON.stringify({ code }),
  });
};

export const registerByEmail = async (name, email, password, walletAddress) => {
  return await fetchInstance(REGISTER_BY_EMAIL, {
    method: "POST",
    body: JSON.stringify({ name, email, password, walletAddress }),
  });
};

export const loginByEmail = async (email, password) => {
  return await fetchInstance(LOGIN_BY_EMAIL, {
    method: "POST",
    body: JSON.stringify({ email, password }),
  });
};

export const verifyEmail = async (code, email) => {
  return await fetchInstance(VERIFY_EMAIL, {
    method: "POST",
    body: JSON.stringify({ code, email }),
  });
};

export const resendEmailVerificationCode = async (email) => {
  return await fetchInstance(RESEND_VERIFICATION, {
    method: "POST",
    body: JSON.stringify({ email }),
  });
};

export const forgotPasswordSendVerification = async (email) => {
  return await fetchInstance(FOGOT_PASSWORD_SEND_VERIFICATION, {
    method: "POST",
    body: JSON.stringify({ email }),
  });
};

export const resetPassword = async (code, email, newPassword) => {
  return await fetchInstance(RESET_PASSWORD, {
    method: "PATCH",
    body: JSON.stringify({ code, email, newPassword }),
  });
};
